export default __webpack_public_path__ + "static/media/mada.16eecf7c.svg";